function Separator() {
    return <span className={"separator"}>•</span>
}

export default Separator;